export const BOOKING_CODES_ENDPOINT_KEY = 'booking-codes'
